export enum CHANNEL_SOURCE {
  BINANCE = 'QfjGf',
  GATEIO = 'LkTBz',
  DESKTOP = 'fXQKP',
  MOBILE = 'ukRCD',
}

export interface ChannelSourceHeader {
  [name: string]: CHANNEL_SOURCE;
}
